import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { EInputType, IInputField } from "../../ui/Input/Input";
import { EInputUpdateAction } from "../../ui/Input/input-context";
import { useInputs } from "../../ui/Input/useInputs";
import { RefHandle } from "../../../shared/RefHandle";
import IExtra from "../../../shared/IExtra";
import { formatCurrency } from "../../../utils/currency-util";
import { extrasDefaultTrue } from "../../../shared/bookingOptions";

interface IProps {
    extra: IExtra;
    currency: string;
}

export enum EInputs {
    value = "value",
}

const Extra: React.ForwardRefRenderFunction<RefHandle<IExtra>, IProps> = ({ extra, currency }, ref) => {
    const { createInput, submit } = useExtraInputs(extra);

    const getData = useCallback(async () => {
      const data = await submit();
      // console.log(data);
      if (!data) return null;
      return { ...extra, ...data };
    }, [extra, submit]);

    useImperativeHandle(ref, () => ({ getData }));

    const isSelected = !!(extra.value && extra.value !== "0" && extra.value.length !== 0);
    //console.log(extra)

    return (
      <tr style={{ 
        fontWeight: isSelected ? "bold" : "normal",
        backgroundColor: isSelected ? "rgb(192 221 255)" : "transparent"
      }}>
        <td style={{ maxWidth: "2rem"}}>{createInput(EInputs.value, {containerStyles: {margin: "0px"}})}</td>
        <td>{extra.name} {extra.code}</td>
        <td style={{ textAlign: "right" }}>{formatCurrency(extra.rate ?? 0)} {currency}</td>
      </tr>
    )
}

const useExtraInputs = (data: IExtra) => {
  const [inputs, setInputs] = useState<IInputField>({
    [EInputs.value]: data?.quant ?
      {
        type: EInputType.number,
        value: data.value ? data.value : "0",
        validation: {
          required: true,
          maxAmount: data.max,
          minAmount: 0
        },
        onBlurModifyValue: (val) => Math.max(0, parseInt(val as string) || 0).toString(),
        disabled: extrasDefaultTrue.includes(data.code)
      }
    :
      {
        type: EInputType.checkbox,
        options: [{ value: "true" }],
        value: (data.value === "Y" || data.value === "true") ? ["true"] : [],
        disabled: extrasDefaultTrue.includes(data.code)
      }
  });

  const { createInput, submit } = useInputs({
    data,
    inputs,
    setInputs,
    updateAction: EInputUpdateAction.EXTRA,
  });

  return { createInput, submit };
}

export default forwardRef(Extra);